<template>
  <div class="d-flex h-100 slideshow-background" :style="backgroundStyle">
    <div id="slide-body" v-if="activeSlide" class="d-flex flex-column w-100 pretty-scroll"
      style="overflow-y: auto; overflow-x: hidden">
      <div class="flex-grow-1 w-100 position-relative">
        <VoterCounts v-if="showVoterCounts" class="position-fixed rounded m-4"
          style="width: 100px; bottom: 0px; right: 0px; z-index: 5" />
        <transition name="slide" :enter-from-class="slideOffset < 0 ? 'slide-right-position' : 'slide-left-position'"
          :leave-to-class="slideOffset < 0 ? 'slide-left-position' : 'slide-right-position'">
          <Slide :slide="activeSlide" :active="true" :key="activeSlide.id" :showLocaleSwitcher="showLocaleSwitcher" />
        </transition>
      </div>
    </div>
    <div v-else class="bg-dark d-flex min-vh-100 w-100 justify-content-center align-items-center">
      <div class="text-center text-white p-2">
        <h3>{{ $t("js.slide_show.no_slide_active") }}</h3>
        <p>{{ $t("js.slide_show.presentation_not_started") }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Slide from "./Slide.vue";
import { mapState } from "pinia";
import VoterCounts from "@/components/shared/VoterCounts.vue";
import { usePresentationStore } from "@/entrypoints/stores/presentation";

export default defineComponent({
  name: "SlideShow",
  components: { VoterCounts, Slide },
  data() {
    return {
      slideOffset: 0,
    }
  },
  props: {
    showLocaleSwitcher: {
      type: Boolean,
      default: true,
    },
    showVoterCounts: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(usePresentationStore, ["slides", "activeSlide"]),
    backgroundStyle() {
      if (this.activeSlide) {
        if (this.activeSlide.background) {
          return {
            backgroundImage: `url("${this.activeSlide.background}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          };
        } else {
          return {
            backgroundImage: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAIAAAC0SDtlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AcGEhcPXNSe4QAAABdJREFUGNNj/PHzFwMpgImBRDCqgSYaABKAAv2s97RbAAAAAElFTkSuQmCC')",
            backgroundPosition: "center",
            backgroundSize: "cover",
          };
        }
      }
    },
  },
  watch: {
    activeSlide: function (newVal, oldVal) {
      if (newVal === undefined || newVal === null) return;

      this.slideOffset = oldVal ? oldVal.position - newVal.position : newVal.position;
    }
  }
});
</script>

<style>
.slideshow-background {
  transition: background-image ease 1s;
  width: 100vw;
  overflow-y: auto;
}
</style>
